import icon1 from '../images/icon/cloud.gif'
import icon2 from '../images/icon/server.gif'
import icon3 from '../images/icon/database.gif'
import icon4 from '../images/icon/cloud-connect.gif'
import icon5 from '../images/icon/connected.gif'
import icon6 from '../images/icon/cloud-computing.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/da-fea_icon01.svg'
import sdicon2 from '../images/icon/da-fea_icon02.svg'
import sdicon3 from '../images/icon/da-fea_icon03.svg'
import sdicon4 from '../images/icon/da-fea_icon04.svg'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'


import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'


import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'



const Services = [
    {
        Id: '1',
        sImg: icon1,
        title: 'Cloud VPS',
        slug: 'Cloud-VPS',
        thumb1: 'Infraestrutura',
        thumb2: 'Virtualização',
        description: 'Servidores virtuais privados em nuvem com alta performance e escalabilidade.',
    },
    {
        Id: '2',
        sImg: icon4,
        title: 'VDI Windows 11',
        slug: 'VDI-Windows-11',
        thumb1: 'Desktop Virtual',
        thumb2: 'Acesso Remoto',
        description: 'Área de trabalho virtual Windows 11 com acesso seguro de qualquer lugar.',
    },
    {
        Id: '3',
        sImg: icon2,
        title: 'Cloud Server',
        slug: 'Cloud-Server',
        thumb1: 'Hospedagem',
        thumb2: 'Gestão',
        description: 'Servidores dedicados com recursos garantidos.',
    },
    {
        Id: '4',
        sImg: icon3,
        title: 'Datacenter Virtual',
        slug: 'Datacenter-Virtual',
        thumb1: 'Infraestrutura',
        thumb2: 'Segurança',
        description: 'Datacenter completo virtualizado com redundância e backup automatizado.',
    },

    {
        Id: '5',
        sImg: icon5,
        title: 'Disaster Recovery',
        slug: 'Disaster-Recovery',
        thumb1: 'Backup',
        thumb2: 'Recuperação',
        description: 'Soluções de recuperação de desastres para garantir a continuidade dos negócios.',
    },
    {
        Id: '6',
        sImg: icon6,
        title: 'Desenvolvimento Web',
        slug: 'Desenvolvimento-Web',
        description: 'Aplicações web modernas e responsivas, e com tecnologia de ponta do mercado.',
    },
    {
        Id: '7',
        sImg: simg1,
        sIcon: sicon1,
        title: 'Gestão de TI',
        slug: 'Gestao-TI',
    },
    {
        Id: '8',
        sImg: simg2,
        sIcon: sicon2,
        title: 'Monitoramento & Segurança',
        slug: 'Monitoramento-Seguranca',
    },
    {
        Id: '9',
        sImg: simg3,
        sIcon: sicon3,
        title: 'Soluções CRM Customizadas',
        slug: 'Solucoes-CRM-Customizadas',
    },
    {
        Id: '10',
        sImg: simg4,
        sIcon: sicon4,
        title: 'Desenvolvimento Web',
        slug: 'Desenvolvimento-Web',
    },
    {
        Id: '11',
        sIcon: sdicon1,
        title: 'Análise de Infraestrutura',
        slug: 'Analise-Infraestrutura',
        description: 'Identificamos oportunidades de otimização na sua infraestrutura atual para migração para nuvem.',
    },
    {
        Id: '12',
        sIcon: sdicon2,
        title: 'Configuração de Ambiente',
        slug: 'Configuracao-Ambiente',
        description: 'Configuramos sua infraestrutura em nuvem com as melhores práticas de segurança e performance.',
    },
    {
        Id: '13',
        sIcon: sdicon3,
        title: 'Automação de Processos',
        slug: 'Automacao-Processos',
        description: 'Implementamos soluções automatizadas para otimizar seus processos de TI e reduzir custos.',
    },
    {
        Id: '14',
        sIcon: sdicon4,
        title: 'Suporte e Treinamento',
        slug: 'Suporte-Treinamento',
        description: 'Oferecemos suporte técnico completo e treinamento para sua equipe adotar as novas tecnologias.',
    },
    {
        Id: '15',
        sIcon: scicon1,
        title: 'Secure your network',
        slug: 'Secure-your-network',
        features: [' Consistently Secure the Enterprise.', 'Apply Al inline to prevent evasive.', 'Simplify network security operations.', ' Adopt Zero Trust across the network.', ' Simplify with AI-Powered SASE.']
    },
    {
        Id: '16',
        sIcon: scicon2,
        title: 'Secure your cloud',
        slug: 'Secure-your-cloud',
        features: ['End-to-End Cloud Security.', 'Real-Time Threat Detection.', 'Identity & Access Management.', 'Data Encryption & Privacy.', 'Compliance & Governance.']
    },
    {
        id: '17',
        sIcon: scicon3,
        title: 'Transform your SOC',
        slug: 'Transform-your-SOC',
        features: [
            'Accelerate Threat Detection',
            'Automate Security Processes',
            'Streamline Incident Response',
            'Attack Surface Management',
            'Integrated Security Monitoring',
        ],
    },
    {
        id: '18',
        sIcon: scicon4,
        title: 'Threat Intel & Response',
        slug: 'Threat-Intel-&-Response',
        features: [
            "Let our experts be of your team.",
            "Move from reactive to proactive.",
            "Get world-class threat intelligence",
            "Every second counts when attack",
            "Make our experience your experience",
        ],
    },
    {
        id: '19',
        sIcon: scicon5,
        title: 'Solutions by industry',
        slug: 'Solutions-by-industry',
        features: [
            'Public sector',
            'Financial services',
            'Manufacturing',
            'Small & medium business solutions',
            'Healthcare',
        ],
    },

    {
        Id: '20',
        sIcon: cdicon1,
        title: 'INFRASTRUCT URE DESIGN',
        slug: 'INFRASTRUCT-URE-DESIGN',
    },
    {
        Id: '21',
        sIcon: cdicon2,
        title: 'COSTS OPTIMIZATION',
        slug: 'COSTS-OPTIMIZATION',
        bgClass: 'cd-dot_bg2',
    },
    {
        Id: '22',
        sIcon: cdicon3,
        title: 'INFRASTRUCTURE AS A CODE',
        slug: 'INFRASTRUCTURE-AS-A-CODE',
        bgClass: 'cd-dot_bg3',
    },
    {
        Id: '23',
        sIcon: cdicon4,
        title: 'Continuous Integration',
        slug: 'Continuous-Integration',
        bgClass: 'cd-dot_bg4',
    },
    {
        Id: '24',
        sIcon: cdicon5,
        title: 'Continuous Deployment',
        slug: 'Continuous-Deployment',
    },
    {
        Id: '25',
        sIcon: cdicon6,
        title: 'Blue Green Deployment',
        slug: 'Blue-Green-Deployment',
        bgClass: 'cd-dot_bg2',
    },
    {
        Id: '26',
        sIcon: '',
        title: 'Data Consistency',
        slug: 'Data-Consistency',
        bgClass: 'cd-dot_bg3'
    },
    {
        Id: '27',
        sIcon: cdicon7,
        title: 'Data Integrity',
        slug: 'Data-Integrity',
        bgClass: 'cd-dot_bg4'
    },
    {
        Id: '28',
        sIcon: cdicon8,
        title: 'Redundancy',
        slug: 'Redundancy',
    },
]

export default Services;